import { PageHeader } from '@ant-design/pro-components'
import { Container, Paragraph } from '@app/components'
import { useRouter } from 'next/router'

export const FrozenWidget: React.FC = () => {
  const router = useRouter()
  const isFrozenRoute = router.route === '/frozen'

  const title = isFrozenRoute ? 'Account Frozen' : 'Maintenance Mode'
  const footerContent = isFrozenRoute ? (
    <Paragraph>
      Due to some irregular payment activity, your account has been temporarily frozen. Please contact
      support@0xcoast.com if you believe this freeze has been placed in error.
    </Paragraph>
  ) : (
    <Paragraph>
      The Mint, Burn, Fund and Withdraw functions are temporarily unavailable while we complete some scheduled
      maintenance. You'll get an email when everything is back in action.
    </Paragraph>
  )

  return (
    <>
      <Container>
        <PageHeader title={title} footer={<>{footerContent}</>} />
      </Container>
    </>
  )
}
